import type {
  AuthV2AssociateSoftwareTokenRequest,
  AuthV2ConfirmForgotPasswordRequest,
  AuthV2ForgotPasswordRequest,
  AuthV2LoginRequest,
  AuthV2RespondChallengeRequest,
  AuthV2VerifySoftwareTokenRequest,
  Configuration,
} from '@repo/api-gw-sdk';
import {
  AuthV2AssociateSoftwareTokenApi,
  AuthV2ConfirmForgotPasswordApi,
  AuthV2ForgotPasswordApi,
  AuthV2LoginApi,
  AuthV2RespondChallengeApi,
  AuthV2VerifySoftwareTokenApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

export const authV2 = (httpClient: HttpClient, config: Configuration) => {
  const loginApi = new AuthV2LoginApi(config);
  const respondChallengeApi = new AuthV2RespondChallengeApi(config);
  const forgotPasswordApi = new AuthV2ForgotPasswordApi(config);
  const confirmForgotPasswordApi = new AuthV2ConfirmForgotPasswordApi(config);
  const associateSoftwareTokenApi = new AuthV2AssociateSoftwareTokenApi(config);
  const verifySoftwareTokenApi = new AuthV2VerifySoftwareTokenApi(config);

  // `domain` is a dev-only tenant override (the backend honors it only in local
  // environments, where there is no tenant subdomain). It is undefined in real
  // environments, where the tenant is resolved from the host.
  return {
    login: (body: AuthV2LoginRequest, domain?: string) =>
      loginApi.authV2Login(body, domain),
    respondChallenge: (body: AuthV2RespondChallengeRequest, domain?: string) =>
      respondChallengeApi.authV2RespondChallenge(body, domain),
    forgotPassword: (body: AuthV2ForgotPasswordRequest) =>
      forgotPasswordApi.authV2ForgotPassword(body),
    confirmForgotPassword: (body: AuthV2ConfirmForgotPasswordRequest) =>
      confirmForgotPasswordApi.authV2ConfirmForgotPassword(body),
    // No `domain` override: these continue an established MFA_SETUP challenge
    // via the Cognito session alone, so they don't resolve a tenant.
    associateSoftwareToken: (body: AuthV2AssociateSoftwareTokenRequest) =>
      associateSoftwareTokenApi.authV2AssociateSoftwareToken(body),
    verifySoftwareToken: (body: AuthV2VerifySoftwareTokenRequest) =>
      verifySoftwareTokenApi.authV2VerifySoftwareToken(body),
  };
};
